import {
  getFeedbackQuestions,
  createFeedback,
  getExternal,
  updateExternal,
  orderChargingPost,
  createAdjustments,
  ticketUpdate,
  getTicketById,
  cancelTicket,
  getTicketTemplate,
  createClients,
  paymentTypeInfo,
  getOptionsTemplate,
  getClientsTemplate,
  getSaleTemplate,
  updateCustomerInfo,
  getAddressByCustomer,
  updateCustomerAddress,
  getClientServiceTemplate,
  getNetworkDetails,
  getplanDetails,
  getPlanDetails,
  searchCustomer,
  getClients,
  getSaleTemplateById,
  makeStatement,
  profilePicture,
  editProfilePicture,
  getProfilePic,
  getDocumentUploadPic,
  getCommandTemplateById,
  addDeviceApi,
  getPlanPacks,
  getCataloguePlans,
  addPlanCatalogue,
  getClientServiceDetailsData,
  getProvisioningList,
  getCancelPlanList,
  cancelPlanPost,
  suspendPlan,
  activatePlan,
  getChangePlansByPlan,
  changePlan,
  serviceActivation,
  serviceWDActivation,
  userByTeam,
  createCustomerTicket,
  createCustomerTicketTask,
  swapTemplate,
  itemDetailsByQuery2,
  swapDevice,
  serviceTerminate,
  getTransactionDetails,
  getDiscount,
  getUsageData,
  getChargeData,
  getClientById,
  getClientDataById,
  applyPromoApi,
  orderDisconnects,
  getBasePlan,
  customerFullSearch,
  getFiscalYears,
  getFiscalQuarters,
  depositTemplate,
  getClientDepositList,
  addRefund,
  postDepositTemplate,
  postrecieverTemplate,
  getSalesPlanCategory,
  downloadReciept,
  ticketDocument,
  redeemption,
  financialTransactionById,
  renewalPlan,
  deallocateClientDevice,
  getOneTimeSales,
  deleteInvoice,
  getChildsByClientId,
  fetchParentClient,
  callCustomerApi,
  updateSpendCap,
  getSpendCap,
  reactivateService,
  getPromotionFeatureList,
  getCreditLimit,
  updateCreditLimit,
  getSlcData,
  redeemVoucher,
  getScheduleOrdersById,
  checkCreditLimitStatus,
  getSwapSerialNumber,
  swapSim,
  getTopup,
} from "../../../http/customer/customer";
export default {
  namespaced: true,
  state: {
    questionsList: [],
    externalData: [],
    profilePic: "",
    profilePics: "",
    clientsDataEditSave: {},
    clients: [],
    template: {},
    serviceTemplate: [],
    clientDetailData: {},
    childList: [],
    ticketTemplate: {},
    transactionDetails: [],
    billMaster: [],
    additional: {},
    oneTimeSales: [],
    disconnect: {},
    networkNodeTemplate: [],
    adjustmentsTemplate: [],
    billDetail: [],
    customerResourceId: null,
    paymentTypeData: null,
    entityList: [],
    itemList: [],
    itemDetail: {},
    saleTemplate: {},
    deviceTemplate: {},
    commandTemplate: [],
    planDataList: [],
    planPacks: [],
    clientDetails: [],
    provisioningList: [],
    cancelPlanList: [],
    chengePlans: {},
    teamUsers: [],
    swapTemplate: [],
    ticketViewById: [],
    financialData: {},
    addressByCustomer: {},
    CustomerByDisconnect: {},
    Discount: [],
    Usagelist: [],
    Chargelist: [],
    basePlans: [],
    fiscalYears: [],
    fiscalQuarters: [],
    financialTransactionList: "",
    editDepositTemplate: [],
    customerFullSearchData: "",
    clientDepositList: [],
    parentClients: [],
    spendCapData: {},
    promotionFeatureList: [],
    creditData: {},
    slcDataList: [],
    scheduleOrdersById: [],
    creditLimitStatus: [],
  },
  actions: {
    async getFeedbackQuestionsAction({ commit }, id) {
      const resp = await getFeedbackQuestions(id);
      commit("SET_FEEDBACK_QUESTIONS", resp.data);
      return resp;
    },
    async createFeedbackAction(_, data) {
      const resp = await createFeedback(data);
      return resp;
    },
    async getExternalAction({ commit }, data) {
      const response = await getExternal(data);
      commit("SET_EXTERNAL", response.data);
      return response;
    },
    async updateExternalAction(_, data) {
      const response = await updateExternal(data);
      return response;
    },
    async callCustomerAction(_, payload) {
      return await callCustomerApi(payload);
    },
    async setClient({ commit }, data) {
      const response = await getClients(data);
      commit("SET_CLIENTS", response.data.pageItems);
      return response;
    },
    async updateCreditLimitAction({ commit }, data) {
      try {
        const response = await updateCreditLimit(data);
        return response;
      } catch (error) {
        // throw error.message;
        throw Error(error.message.errors[0].defaultUserMessage);
      }
    },

    async setBasePlans({ commit }) {
      const response = await getBasePlan();
      commit("SET_BASE_PLAN", response.data.allPlanDatas);
      return response;
    },

    async setClientTemplate({ commit }) {
      const response = await getClientsTemplate();
      commit("SET_CLIENTS_TEMPLATE", response.data);
      return response;
    },
    async setCreditLimit({ commit }, id) {
      const response = await getCreditLimit(id);
      commit("SET_CREDIT_LIMIT", response.data);
      return response;
    },
    async checkCreditLimitStatusAction({ commit }, id) {
      const response = await checkCreditLimitStatus(id);
      commit("SET_CREDIT_LIMIT_STATUS_DATA", response.data);
      return response;
    },
    async setParentClients({ commit }, query) {
      const response = await fetchParentClient(query);
      commit("SET_PARENT_CLIENTS", response.data);
      return response;
    },

    async setClientServiceTemplate({ commit }) {
      const response = await getClientServiceTemplate();
      commit("SET_CLIENTS_SERVICE_TEMPLATE", response.data.serviceData);
      return response;
    },
    async customerFullSearchAction({ commit }, data) {
      const response = await customerFullSearch(data);
      commit("SET_CUSTOMER_FULL_SEARCH", response.data);
      return response;
    },
    async setClientNetworkTemplate({ commit }, id) {
      const response = await getNetworkDetails(id);
      commit("SET_CLIENTS_NETWORK_TEMPLATE", response.data);
    },
    async setClientDetailData({ commit }, data) {
      const res = await getClientById(data);
      commit("SET_CLIENT_DATA", res.data);
      return res;
    },
    setClientNotes({ commit }, data) {
      commit("SET_CLIENT_NOTES", data);
    },

    async setTicketTemplate({ commit }) {
      const response = await getTicketTemplate();
      commit("SET_TICKET_TEMPLATE", response.data);
      return response;
    },
    setEventOrderTemplate({ commit }, data) {
      commit("SET_EVENT_ORDER_TEMPLATE", data);
    },
    async setTransactionDetails({ commit }, data) {
      const resp = await getTransactionDetails(data.params, data.clientId);
      commit("SET_TRANSACTION_DETAILS", resp.data.pageItems);
      return resp;
    },

    setAddAdditionalInfo({ commit }, data) {
      commit("SET_CLIENT_ADDADDITIONAL_INFO", data);
    },

    setOrderDisconnect({ commit }, data) {
      commit("SET_ORDER_DISCONNECT", data);
    },
    setAdjustmentsTemplate({ commit }, data) {
      commit("SET_ADJUSTMENTS_TEMPLATE", data);
    },

    async createCustomerAction({ commit }, data) {
      const resp = await createClients(data);
      commit("CREATE_CUSTOMER_ACTION", resp.data.resourceId);
      return resp;
    },
    async clearResourceId({ commit }) {
      commit("CLEAR_RESOURCE_ID");
    },
    async paymentTypeAction({ commit }, payload) {
      const resp = await paymentTypeInfo(payload);
      commit("PAYMENT_TYPE_INFO", resp.data.resourceId);
      return resp;
    },
    async setOptionsTemplate({ commit }) {
      const response = await getOptionsTemplate();
      commit("SET_OPTIONS_TEMPLATE", response.data.officeOptions);
      return response;
    },

    async setSaleTemplate({ commit }) {
      const response = await getSaleTemplate();
      commit("SET_SAlE_TEMPLATE", response.data);
      return response;
    },

    async getPlanDetail(_, data) {
      const res = await getplanDetails(data);
      return res;
    },
    async setCustomerSales(_, data) {
      const response = await getSalesPlanCategory(data);
      return response;
    },
    async deallocateClientDeviceAction(_, payload) {
      return await deallocateClientDevice(payload.id, payload.data);
    },

    async setCustomerSearch({ commit }, data) {
      let resp = await searchCustomer(data.type, data.val);
      commit("SET_CLIENTS", [resp.data]);
    },
    async getOneTimeSalesAction({ commit }, data) {
      let resp = await getOneTimeSales(data);
      commit("SET_ONE_TIME_SALES", resp.data);
      return resp;
    },

    async deviceTemplateAction({ commit }, id) {
      const resp = await getSaleTemplateById(id);
      commit("SET_DEVICE_TEMPLATE", resp.data);
      return resp;
    },
    async provisioningCommandTemplate({ commit }, id) {
      const resp = await getCommandTemplateById(id);
      commit("SET_PROVISIONING_COMMAND_TEMPLATE", resp.data);
      return resp;
    },
    async addDeviceAction(_, data) {
      const res = await addDeviceApi(data.id, data.data);
      return res;
    },
    async getPlanPackAction({ commit }) {
      const resp = await getPlanPacks();
      commit("SET_PLAN_PACKS", resp.data.allPlanDatas);
      return resp;
    },
    async getPlanCatalogue({ commit }, data) {
      const resp = await getCataloguePlans(
        data.id,
        data.clientId,
        data.serviceId
      );
      commit("SET_PLAN_CATA", resp.data.planData);
      return resp;
    },
    async addPlanCatalogueAction(_, data) {
      const res = await addPlanCatalogue(data.id, data.data);
      return res;
    },
    async getClientServiceDetailsQueryAction({ commit }, data) {
      const resp = await getClientServiceDetailsData(data);
      commit("SET_CLIENT_DETAILS", resp.data.ServiceParameterData);
      return resp;
    },
    async getProvisioningDetails({ commit }, id) {
      const resp = await getProvisioningList(id);
      commit("SET_PROVISIONING_DETAIL", resp.data);
      return resp;
    },
    async getCancelPlans({ commit }, data) {
      const resp = await getCancelPlanList(data.clientId, data.serviceId);
      commit("SET_CANCEL_PLANS", resp.data.clientOrders);
      return resp;
    },

    async cancelPlansAction(_, data) {
      const res = await cancelPlanPost(data.id, data.data);
      return res;
    },
    async suspendPlanAction(_, data) {
      const res = await suspendPlan(data.id, data.data);
      return res;
    },
    async activatePlanAction(_, data) {
      const res = await activatePlan(data.id, data.data);
      return res;
    },
    async getChangePlansByPlanAction({ commit }, data) {
      const resp = await getChangePlansByPlan(
        data.clientId,
        data.serviceId,
        data.planId,
        data.salesId
      );
      commit("SET_CHANGE_PLANS_BY_PLAN", resp.data);
      return resp;
    },
    async changePlanAction(_, data) {
      const res = await changePlan(data.id, data.data);
      return res;
    },
    async serviceActivationAction(_, data) {
      const res = await serviceActivation(data.id, data.data);
      return res;
    },
    async serviceWDActivationAction(_, data) {
      const res = await serviceWDActivation(data.id, data.data);
      return res;
    },
    async getUserByTeam({ commit }, id) {
      const resp = await userByTeam(id);
      commit("SET_USER_BY_TEAM", resp.data.teamUsers);
      return resp;
    },
    async addCustomerTicket(_, data) {
      const res = await createCustomerTicket(data.id, data.data);
      return res;
    },
    async addCustomerTicketTask(_, data) {
      const res = await createCustomerTicketTask(data.clientId, data.data);
      return res;
    },
    async getSwapTemplate({ commit }) {
      const resp = await swapTemplate();
      commit("SET_SWAP_TEMPLATE", resp.data.swapDevicesReasons);
      return resp;
    },
    async setItemDetailsByQuery2({ commit }, query) {
      const response = await itemDetailsByQuery2(
        query.item,
        query.loc,
        query.sl
      );
      commit("ITEM_DETAILS_BY_QUERY", response.data);
      return response;
    },
    async swapDeviceAction(_, data) {
      const res = await swapDevice(data);
      return res;
    },
    async serviceTerminateAction(_, data) {
      const res = await serviceTerminate(data.id, data.data);
      return res;
    },

    async setClientDepositListAction({ commit }, id) {
      const resp = await getClientDepositList(id);
      commit("SET_CLIENT_DEPOSIT_LIST", resp.data);
      return resp;
    },

    async downloadReceipt(_, data) {
      const resp = await downloadReciept(
        data.mode,
        data.clientId,
        data.transactionId
      );
      return resp;
    },
    async createAdjustmentAction(_, data) {
      const res = await createAdjustments(data.id, data.data);
      return res;
    },
    async deleteInvoiceAction(_, data) {
      const res = await deleteInvoice(data.resourceId);
      return res;
    },
    async createStatement(_, data) {
      const res = await makeStatement(data.id, data.data);
      return res;
    },

    async uploadTicketDocument(_, data) {
      const res = await ticketDocument(data.id, data.data);
      return res;
    },
    async uploadProfilePicture(_, data) {
      const res = await profilePicture(data.clientId, data.formData);
      return res;
    },
    async updateProfilePicture(_, data) {
      const res = await editProfilePicture(data.clientId, data.formData);
      return res;
    },
    async getClientProfilePic({ commit }, id) {
      try {
        const res = await getProfilePic(id);
        commit("SET_PROFILE_PICTURE", res.data);
        return res;
      } catch (error) {
        commit("SET_PROFILE_PICTURE", "");
      }
    },
    async getClientProfilePics({ commit }, { id, docId }) {
      try {
        const res = await getDocumentUploadPic(id, docId);
        commit("SET_FILE_PICTURE", res.data);
        return res;
      } catch (error) {
        commit("SET_FILE_PICTURE", "");
      }
    },
    async addRefundAction(_, payload) {
      return await addRefund(payload.id, payload.data);
    },

    async updateTicket(_, data) {
      const res = await ticketUpdate(data.id, data.data);
      return res;
    },
    async cancelTicketAction(_, data) {
      const res = await cancelTicket(data.id, data.data);
      return res;
    },
    async setsTicketById({ commit }, id) {
      const resp = await getTicketById(id);
      commit("SET_TICKETVIEW_BY_ID", resp.data);
      return resp;
    },
    async orderChargingAction(_, payload) {
      return await orderChargingPost(payload);
    },
    async fetchdepositTemplate({ commit }, id) {
      const res = await depositTemplate(id);
      commit("DEPOSIT_TEMPLATE", res.data);
      return res;
    },
    async depositTemplateAction(_, data) {
      const res = await postDepositTemplate(data);
      return res;
    },
    async recieverTemplateAction(_, data) {
      const res = await postrecieverTemplate(data);
      return res;
    },
    async redeemAction(_, data) {
      const res = await redeemption(data);
      return res;
    },

    async getFinancialTransaction({ commit }, data) {
      const resp = await financialTransactionById(data);
      commit("SET_FINANCIAL_TRANSACTION_DATA", resp.data.transactionsDatas);
      return resp;
    },
    async editCustomerInfo(_, data) {
      const resp = await updateCustomerInfo(data.id, data.data);
      return resp;
    },
    async editCustomerAddress(_, data) {
      const resp = await updateCustomerAddress(data.id, data.data);
      return resp;
    },
    async getCustomerAddress({ commit }, data) {
      const resp = await getAddressByCustomer(data);
      commit("SET_ADDRESS_BY_CUSTOMER", resp.data);
      return resp;
    },
    async renewalAction(_, data) {
      const resp = await renewalPlan(data.id, data.data);
      return resp;
    },
    async planDetailsAction(_, id) {
      const resp = await getPlanDetails(id);
      return resp;
    },
    async setOrderDisconnects({ commit }) {
      const resp = await orderDisconnects();
      commit("SET_ORDER_DISCONNECTS", resp.data);
      return resp;
    },
    async setDiscountById({ commit }, id) {
      const resp = await getDiscount(id);
      commit("SET_DISCOUNT_BY_ID", resp.data);
      return resp;
    },
    async setUsageData({ commit }, id) {
      const resp = await getUsageData(id);
      commit("SET_USAGE_DATA", resp.data);
      return resp;
    },

    async fetchChargeData({ commit }, id) {
      const resp = await getChargeData(id);
      commit("SET_CHARGE_DATA", resp.data);
      return resp;
    },
    async applyPromoAction(_, data) {
      return await applyPromoApi(data.id, data.data);
    },
    async setFiscalYears({ commit }) {
      const response = await getFiscalYears();
      commit("FISCAL_YEARS", response.data);
      return response;
    },
    async setFiscalQuarters({ commit }) {
      const response = await getFiscalQuarters();
      commit("FISCAL_QUARTERS", response.data);
      return response;
    },
    async getChildsByClientIdAction({ commit }, data) {
      const response = await getChildsByClientId(data);
      commit("SET_CLIENT_CHILD", response.data);
      return response;
    },
    async updateSpendCapAction(_, data) {
      return await updateSpendCap(data.id, data.data);
    },
    async getSpendCapAction({ commit }, data) {
      const response = await getSpendCap(data);
      commit("SET_SPEND_CAP", response.data);
      return response;
    },
    async reactivateServiceAction(_, data) {
      const res = await reactivateService(data.id, data.data);
      return res;
    },
    async redeemVoucherAction(_, data) {
      const res = await redeemVoucher(data);
      return res;
    },
    async setFeatureList({ commit }, data) {
      const response = await getPromotionFeatureList(data);
      commit("SET_PROMOTION_FEATURE_LIST", response.data);
      return response;
    },
    async getScheduleOrdersByIdAction({ commit }, data) {
      const response = await getScheduleOrdersById(data);
      commit("SET_SCHEDULE_ORDERS_BY_ID", response.data);
      return response;
    },
    async getSlcDataAction({ commit }, data) {
      const response = await getSlcData(data);
      commit("SET_SLC_DATA", response.data);
      return response;
    },
    async getSwapSerialNumberAction({ commit }, data) {
      const response = await getSwapSerialNumber(data);
      return response;
    },
    async swapSimAction(_, data) {
      const response = await swapSim(data);
      return response;
    },
    async getTopupAction(_, data) {
      const response = await getTopup(data);
      return response;
    },
  },
  mutations: {
    SET_SLC_DATA(state, payload) {
      state.slcDataList = payload;
    },
    SET_SCHEDULE_ORDERS_BY_ID(state, payload) {
      state.scheduleOrdersById = payload;
    },
    SET_CREDIT_LIMIT_STATUS_DATA(state, payload) {
      state.creditLimitStatus = payload;
    },
    SET_FEEDBACK_QUESTIONS(state, payload) {
      state.questionsList = payload;
    },
    SET_EXTERNAL(state, payload) {
      state.externalData = payload;
    },
    DEPOSIT_TEMPLATE(state, payload) {
      state.editDepositTemplate = payload;
    },
    FISCAL_YEARS(state, payload) {
      state.fiscalYears = payload;
    },
    FISCAL_QUARTERS(state, payload) {
      state.fiscalQuarters = payload;
    },
    SET_CLIENTS(state, payload) {
      state.clients = payload;
    },
    SET_CREDIT_LIMIT(state, payload) {
      state.creditData = payload;
    },
    CLEAR_CLIENTS_LIST(state) {
      state.clients = [];
    },
    SET_CLIENTS_TEMPLATE(state, payload) {
      state.template = payload;
    },
    SET_ONE_TIME_SALES(state, payload) {
      state.oneTimeSales = payload;
    },
    SET_PARENT_CLIENTS(state, payload) {
      state.parentClients = payload;
    },

    SET_CLIENTS_SERVICE_TEMPLATE(state, payload) {
      state.serviceTemplate = payload;
    },
    SET_CUSTOMER_FULL_SEARCH(state, payload) {
      state.customerFullSearchData = payload;
    },

    SET_CLIENTS_NETWORK_TEMPLATE(state, payload) {
      state.networkNodeTemplate = payload;
    },
    SET_CLIENT_DATA(state, payload) {
      state.clientDetailData = payload;
    },
    SET_CLIENT_DEPOSIT_LIST(state, payload) {
      state.clientDepositList = payload;
    },

    SET_CLIENT_CHILD(state, payload) {
      state.childList = payload;
    },

    SET_BASE_PLAN(state, payload) {
      state.basePlans = payload;
    },
    SET_TICKET_TEMPLATE(state, payload) {
      state.ticketTemplate = payload;
    },
    SET_TRANSACTION_DETAILS(state, payload) {
      state.transactionDetails = payload;
    },

    SET_CLIENT_ADDADDITIONAL_INFO(state, payload) {
      state.additional = [payload];
    },

    SET_ORDER_DISCONNECT(state, payload) {
      state.disconnect = payload;
    },
    SET_ADJUSTMENTS_TEMPLATE(state, payload) {
      state.adjustmentsTemplate = payload;
    },

    CREATE_CUSTOMER_ACTION(state, payload) {
      state.customerResourceId = payload;
    },
    CLEAR_RESOURCE_ID(state) {
      state.customerResourceId = null;
    },
    PAYMENT_TYPE_INFO(state, payload) {
      state.paymentTypeData = payload;
    },
    SET_OPTIONS_TEMPLATE(state, payload) {
      state.entityList = payload;
    },
    ITEM_DETAILS_BY_QUERY(state, payload) {
      state.itemList = payload.serialNumbers;
    },

    SET_SAlE_TEMPLATE(state, payload) {
      state.saleTemplate = payload;
    },

    SET_DEVICE_TEMPLATE(state, payload) {
      state.deviceTemplate = payload;
    },
    SET_PROVISIONING_COMMAND_TEMPLATE(state, payload) {
      state.commandTemplate = payload;
    },
    SET_PLAN_PACKS(state, payload) {
      state.planPacks = payload;
    },
    SET_PLAN_CATA(state, payload) {
      state.planDataList = payload;
    },
    SET_CLIENT_DETAILS(state, payload) {
      state.clientDetails = payload;
    },
    SET_PROVISIONING_DETAIL(state, payload) {
      state.provisioningList = payload;
    },
    SET_CANCEL_PLANS(state, payload) {
      state.cancelPlanList = payload;
    },

    SET_CHANGE_PLANS_BY_PLAN(state, payload) {
      state.chengePlans = payload;
    },
    SET_USER_BY_TEAM(state, payload) {
      state.teamUsers = payload;
    },
    SET_SWAP_TEMPLATE(state, payload) {
      state.swapTemplate = payload;
    },
    SET_TICKETVIEW_BY_ID(state, payload) {
      state.ticketViewById = payload;
    },
    SET_PROFILE_PICTURE(state, payload) {
      state.profilePic = payload;
    },
    SET_FILE_PICTURE(state, payload) {
      state.profilePics = payload;
    },
    SET_FINANCIAL_TRANSACTION_DATA(state, payload) {
      state.financialData = payload;
    },
    SET_ADDRESS_BY_CUSTOMER(state, payload) {
      state.addressByCustomer = payload;
    },
    SET_ORDER_DISCONNECTS(state, payload) {
      state.CustomerByDisconnect = payload;
    },
    SET_DISCOUNT_BY_ID(state, payload) {
      state.Discount = payload;
    },
    SET_USAGE_DATA(state, payload) {
      state.Usagelist = payload;
    },

    SET_CHARGE_DATA(state, payload) {
      state.Chargelist = payload;
    },
    SET_SPEND_CAP(state, payload) {
      state.spendCapData = payload;
    },
    SET_PROMOTION_FEATURE_LIST(state, payload) {
      state.promotionFeatureList = payload;
    },
  },
  getters: {
    putClientSave(state) {
      return state.clientsDataEditSave;
    },

    getClientsList(state) {
      return state.clients;
    },
    getClientsTemplate(state) {
      return state.template;
    },
    getClientsServiceTemplate(state) {
      return state.serviceTemplate;
    },
    getClientsNetworkTemplate(state) {
      return state.networkNodeTemplate;
    },
    getAdjustmentsTemplate(state) {
      return state.adjustmentsTemplate;
    },
    getClientDetailData(state) {
      return state.clientDetailData;
    },
    getClientChild(state) {
      return state.childList;
    },

    getTicketTemplate(state) {
      return state.ticketTemplate;
    },
    getTransactionDetails(state) {
      return state.transactionDetails;
    },

    // additional

    // getOrderDisconnect(state) {
    //   return state.disconnect;
    // },
  },
};
